import React from 'react';
import PropTypes from 'prop-types';

import PhotoSelectionOverlay from './PhotoSelectionOverlay';
import withModal from '../../../../../../../../components/global/modal/withModal';

export const ALBUM_SLIDESHOW_DESIGNER_PHOTO_SELECTION_MODAL =
  'modal/ALBUM_SLIDESHOW_DESIGNER_PHOTO_SELECTION';

const propTypes = { onRequestClose: PropTypes.func };

const PhotoSelectionOverlayModal = ({ onRequestClose, ...props }) => {
  return <PhotoSelectionOverlay onClose={onRequestClose} {...props} />;
};

PhotoSelectionOverlayModal.propTypes = propTypes;

export default withModal(PhotoSelectionOverlayModal, {
  name: ALBUM_SLIDESHOW_DESIGNER_PHOTO_SELECTION_MODAL,
  dismissible: false,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  shouldCloseOnOverlayClick: false,
  className: 'slideshow-designer-photo-selection-modal modal-floating-panel',
});
